// TabContent1.js
import React, { useState, useEffect } from 'react';
import ProgressionTab from '../../../../theme/ProgressionBuilder/ProgressionTab';
import { useTheme } from '@emotion/react';
import Text from '../../../../theme/text/Text';
import { useTranslation } from 'react-i18next';
import { Box, ButtonBase, InputBase } from '@mui/material';
import { tokens } from '../../../../../theme';
import NumberInput from '../../../../theme/inputs/NumberInput';
import ShDateRangePicker from "../../../../theme/ShDateRangePicker";
import ShValidatedInput from '../../../../theme/inputs/ShValidatedInput';
import { useDispatch } from 'react-redux';
import * as yup from "yup";
import { yupRequired, yupNumberRequired } from '../../../../../utils/validation';
import { setTabErrors } from '../../../../../newapi/global/progressionTabSlice';
import { useGetSuppliersSelectQuery } from '../../../../../newapi/global/supplier/supplierSlice';
import ShValidatedInputDropdown from '../../../../theme/dropdowns/ShValidatedInputDropdown';
import { general_states } from '../../../../../utils/staticEnums';
import ShSwitch from '../../../../theme/inputs/ShSwitch';
import { DropdownBaseV2, ShDropdownSearchQuery } from '../../../../theme/dropdowns/Dropdown';
import { useGetRelationsSelectQuery } from '../../../../../newapi/global/relation/relationSlice';

/**
 * TabContent1 Component
 * 
 * Props:
 * - handleDataUpdate: Function, updates the data in the Redux state.
 * - handleNext: Function, navigates to the next tab.
 */
const Content = (props) => {
    const theme = useTheme();
    const {t} = useTranslation();
    const colors = tokens(theme.palette.mode);
    const data = { ...props.data };
    const dispatch = useDispatch();
    const {data:relations, isLoading, isFetching} = useGetRelationsSelectQuery();
        
    // const { data: suppliers, isLoading } = useGetSuppliersSelectQuery();

    const handleInput = (key, val) => {
        props.handleDataUpdate({ [key]: val });
        dispatch(setTabErrors({ ...props.errors, [key]: '' }));
    };

    const select = (date) => {
        const formattedDate = date[0].startDate.toISOString().split('T')[0];
        props.handleDataUpdate({ shipmentDate: formattedDate });
    }

    useEffect(() => {
        if(props.scannedValue !== "none"){
            props.handleDataUpdate({ 
                name: props.scannedValue,
            });
        }
    },[])

    return (
        <>
            <Box 
                sx={{
                    display:'flex',
                    flexDirection:"column",
                }}
            >
                 <Box
                    sx={{
                        width:1,
                        display:"flex",
                        alignItems:"center",
                        justifyContent:"space-between",
                        gap:7
                    }}
                >

                    <Box
                        sx={{
                            width:140,
                        }}
                    >
                        <Text>{t("relation")}</Text>
                    </Box>

                    <DropdownBaseV2
                        key={data.relation}
                        name={"relation"}
                        onChange={(selected) => {
                            props.handleDataUpdate({
                                "relationId": relations[selected].id,
                                "relation": relations[selected],
                            });
                            dispatch(setTabErrors({
                                ...props.errors,
                                ["relationId"]: '',
                                ["relation"]: '',
                            }));
                        }}
                        displayName={"name"}
                        options={relations}
                        closeOnSelection
                        resetOnSelection
                        multiple={false}
                        selected={relations?.findIndex(relation => relation.id === data.relationId) ?? -1}
                        searchOptions={{ enabled: true, placeholder: t("search") }}
                    >
                        {({anchorEl,onClick}) => (
                            <ButtonBase
                                onClick={onClick}
                                sx={{
                                    flex:1,
                                    backgroundColor : `${theme.palette.mode === "dark" ?colors.grey[300] : colors.grey[100]}`,
                                    borderRadius:4,
                                    display:"flex",
                                    height:32,
                                    display:'flex',
                                    alignItems:'center',
                                    justifyContent:'center',
                                    border: props.errors.relationId ? `1px solid ${colors.red[100]}` : 'none',
                                }}
                            >
                                <Text bold color={props.errors.relationId ? colors.red[100] : undefined}>
                                    {data.relation ? data.relation.name : t("no_selection")}
                                </Text>

                            </ButtonBase>
                        )}
                    </DropdownBaseV2>


                </Box>
                {props.errors.relationId && (
                    <Box sx={{ width: 1, display: 'flex', justifyContent: 'flex-end', mt: 0.5 }}>
                        <Box sx={{ flex: 1, ml: '140px', paddingLeft: 7 }}>
                            <Text variant="red" sx={{ fontSize: '0.75rem' }}>
                                {props.errors.relationId}
                            </Text>
                        </Box>
                    </Box>
                )}
                <Box 
                    sx={{
                        width:1,
                        paddingTop: 1.5,
                        display:"flex",
                        justifyContent:"space-between",
                        gap:7
                    }}
                >
                    
                    <Box
                        sx={{
                            width:140,
                            height:32,
                            display:"flex",
                            alignItems:"center",
                        }}
                    >
                        <Text>{t("name")}</Text>
                    </Box>
                    
                    <Box
                        sx={{
                            flex:1,
                            borderRadius:4,
                            display:"flex",
                        }}
                    >
                        <ShValidatedInput
                            name="name"
                            value={data.name}
                            onChange={handleInput}
                            error={props.errors.name}
                        />
                    </Box>
                    
                </Box>
                <Box 
                    sx={{
                        paddingTop: 1.5,
                        width:1,
                        display:"flex",
                        alignItems:"center",
                        justifyContent:"space-between",
                        gap:7
                    }}
                >
                    <Box
                        sx={{
                            width:140,
                        }}
                    >
                        <Text>{t("trackandtrace")}</Text>
                    </Box>
                    <Box
                        sx={{
                            flex:1,
                            backgroundColor : `${theme.palette.mode === "dark" ?colors.grey[300] : colors.grey[100]}`,
                            borderRadius:4,
                            display:"flex",
                            height:32
                        }}
                    >
                        <InputBase 
                            autoFocus
                            sx={{
                                px:2,
                                // minWidth: 200,
                                color:colors.txt["primary"],
                                lineHeight:"32px",
                            }}
                            value={data.trackandtrace}
                            onChange={(e) => handleInput('trackandtrace', e.target.value)}
                            onKeyDown={(e) => {
                                if(e.key === "Enter") {
                                    props.handleNext();
                                }
                            }}
                        />
                    </Box>
                </Box>
                
                {/* <Box 
                    sx={{
                        width:1,
                        display:"flex",
                        paddingTop: 1.5,
                        justifyContent:"space-between",
                        gap:7,
                    }}
                >
                    
                    <Box
                        sx={{
                            width:140,
                            display:"flex",
                            alignItems:"center",
                            height:32,
                        }}
                    >
                        <Text>{t("trackandtrace")}</Text>
                    </Box>
                   
                    <Box
                        sx={{
                            flex:1,
                            borderRadius:4,
                            display:"flex",
                        }}
                    >
                        <ShValidatedInput
                            name="trackandtrace"
                            value={data.trackandtrace}
                            onChange={handleInput}
                            error={props.errors.trackandtrace}
                        />
                    </Box>
                </Box> */}

                {/* <Box 
                    sx={{
                        mt:1.5,
                        width:1,
                        display:"flex",
                        alignItems:"center",
                        justifyContent:"space-between",
                        backgroundColor : colors.red[100],
                        gap:5,
                        borderRadius:4,
                        px:2,
                    }}
                >
                    <Box
                        sx={{
                            width:140,
                            display:"flex",
                            alignItems:"center",
                        }}
                    >
                        <Text variant="red" bold>{t("unsellable")}</Text>
                    </Box>
                   
                    <Box
                        sx={{
                            flex:1,
                            borderRadius:4,
                            display:"flex",
                            alignItems:"center",
                        }}
                    >
                        <ShSwitch
                            value={data.rejectAll}
                            onChange={(event) => {
                                // console.log(event.target.checked);
                                handleInput('rejectAll', event.target.checked)
                            }}
                        />
                    </Box>
                </Box> */}
            </Box>
        </>
    );
};

const Details = (props) => {
    const {t} = useTranslation();
    const schema = yup.object({
        relationId: yupNumberRequired('relation',t),
        name: yupRequired('name',t),
    });


    return (
        <ProgressionTab 
            tabId="tabDetails" 
            subtitle={t("Details")} 
            step={1}
            nextTab={"tabReturnLines"}
            maxSteps={2}
            schema={schema}
        >
            <Content scannedValue={props.scannedValue}/>
        </ProgressionTab>
    )
}

export default Details;

